export const PasswordResetTranslations = {
  en: {
    passwordReset: {
      title: "Password Reset",
      subtitle: "Set a new password",
      passwordLabel: "Password",
      confirmPasswordLabel: "Confirm Password",
      passwordInvalid: "Please provide a valid password (min 6 characters).",
      passwordsDoNotMatch: "Passwords do not match.",
      confirmPasswordInvalid: "Please confirm your password (min 6 characters).",
      resetButton: "Reset Password",
      backToLogin: "Back to login",
    },
  },
  es: {
    passwordReset: {
      title: "Restablecer contraseña",
      subtitle: "Configura una nueva contraseña",
      passwordLabel: "Contraseña",
      confirmPasswordLabel: "Confirmar contraseña",
      passwordInvalid: "Por favor ingresa una contraseña válida (mínimo 6 caracteres).",
      passwordsDoNotMatch: "Las contraseñas no coinciden.",
      confirmPasswordInvalid: "Por favor confirma tu contraseña (mínimo 6 caracteres).",
      resetButton: "Restablecer contraseña",
      backToLogin: "Volver al inicio de sesión",
    },
  },
};
